// extracted by mini-css-extract-plugin
export default {"section":"Carousel_section__fROgJ","title":"Carousel_title__0NHlp","img":"Carousel_img__S-Uhr"};